<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="project-settings-container">
    <div class="project-settings-content">
        <div class="container">
            <div class="row project-name-header no-gutters">
                <h2 class="col">Project settings</h2>
                <button (click)="hide()" class="close" windeActionIcon>
                    <sui-svg-icon icon="angle-left" windeGrey/>
                </button>
            </div>
        </div>
    </div>
    <div class="settings-separator" style="margin-top: 0"></div>

    <div class="container">
        <div *ngIf="projectStateService.isBugReport()" class="row no-gutters btn-action">
            This project was generated by WiNDE during bug report registration. You cannot clone or move it.
        </div>

        <div *ngIf="projectStateService.isPotentiallyCorruptedProject()" class="row no-gutters btn-action">
            {{ 'error.validation.projectIsPotentiallyCorrupted' | translate }}
        </div>

        <div *ngIf="projectMigrationStateService.hasOriginProject()" class="row no-gutters btn-action">
            This project was generated by WiNDE during automatic migration. Link to the original project : &nbsp;
            <a
                    [href]="projectMigrationStateService.getOriginProjectUrl()"
                    class="btn btn-link align-baseline p-0"
                    rel="noopener"
                    target="_blank"
            >
                {{ projectMigrationStateService.getOriginProjectName() }}
            </a>
        </div>

        <div class="row no-gutters">
            <button
                    (click)="openEditWindow()"
                    [disabled]="!historyService.isEditModeEnabled"
                    class="btn btn-link btn-action btn--open-project-settings"
            >
                Edit settings
            </button>
        </div>

        <div *ngIf="!projectStateService.isBugReport() && !projectStateService.isPotentiallyCorruptedProject()" class="row no-gutters">
            <button
                    (click)="saveAsWindow()"
                    *windeHasAnyAuthority="userAuthorities.PROJECT_EDIT"
                    class="btn btn-link btn-action btn--clone-dialog"
            >
                Save as
            </button>
        </div>

        <div *ngIf="projectStateService.isPotentiallyCorruptedProject()" class="row no-gutters">
            <button
                    (click)="migrateProject()"
                    *windeHasAnyAuthority="userAuthorities.PROJECT_EDIT"
                    class="btn btn-link btn-action btn--clone-dialog"
            >
                Migrate project
            </button>
        </div>

        <div *ngIf="historyService.logicalTopology.layersModeEnabled" class="row no-gutters">
            <button
                    (click)="openLayersSettingsWindow()"
                    [disabled]="!historyService.isEditModeEnabled"
                    class="btn btn-link btn-action btn--modify-layers-dialog"
            >
                Modify layers settings
            </button>
        </div>

        @if (historyService.isEditModeEnabled && projectStateService.isInterchangeExportSupported() && (systemInfo$ | async).projectInterchange.exportEnabled) {
            <div class="row no-gutters" *windeHasAnyAuthority="userAuthorities.ALL_SIKLU">
                <button
                        (click)="exportProjectInterchangeArchive()"
                        class="btn btn-link btn-action btn--modify-layers-dialog"
                >
                    Export Project Interchange file
                </button>
            </div>
        }

    </div>
</div>
